import { render, staticRenderFns } from "./ChangeVariant.vue?vue&type=template&id=4c653ad4"
import script from "./ChangeVariant.vue?vue&type=script&lang=js"
export * from "./ChangeVariant.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports